// MobileHeader.jsx (shell)
// Thin wrapper over the DS MobileHeader primitive that preserves this shell's
// existing prop shape (title / subtitle / connected / onSearch / onAvatar) so
// AppShell keeps working unchanged. Maps them onto the primitive's generalized
// slots: the connection dot -> `status`, the search button -> an `actions`
// entry, and the session-ring avatar -> `avatar`.
//
// Theme-aware via DS CSS vars. Honors the top safe-area inset (notch).
import React from "react";
import { MobileHeader as DSMobileHeader } from "../ds";

const SearchIcon = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.3-4.3" />
  </svg>
);

export default function MobileHeader({ title, subtitle, connected = true, onSearch, onAvatar }) {
  return (
    <DSMobileHeader
      title={title}
      subtitle={subtitle}
      // Match legacy behavior: the connection dot only shows alongside a subtitle.
      status={subtitle ? { connected } : undefined}
      actions={[{ key: "search", icon: SearchIcon, onClick: onSearch, "aria-label": "Search" }]}
      avatar={{ initial: "D", onClick: onAvatar, "aria-label": "Account and menu" }}
    />
  );
}
